// extracted by mini-css-extract-plugin
export default {"navOne":"kpac7eeB1NrVppEp_jWeF","navThree":"_1Ct8uVmbVu0G5L3HV_Syph","navTwo":"_3cf5ec_opPt1XskHptoFX3","house":"_2n5CBfzbI5H8yQypyRb4Xa"};